// extracted by mini-css-extract-plugin
export default {"heading":"Applicabilty_heading__5s+a8","text-orange":"Applicabilty_text-orange__uXVjk"};